<template>
  <div>
    <!--表单-->
    <van-cell-group class="applyForm">
      <van-cell title="门店标志" is-link class="storeInfo__logo" :to="{path:'/storeAvatar',query:{store_id:store_id}}">
        <van-uploader class="upload_storeImg"  :preview-size="50" v-if="!storeImg_url" />
        <van-image fit="contain" width="50" height="50" :src="storeImg_url" v-if="storeImg_url" @click="clickPreview" />
      </van-cell>
      <van-field v-model="addressDetails" rows="1" autosize label="地址" type="textarea" placeholder="请输入详细地址" right-icon="arrow" input-align="right" />
      <van-field v-model="phoneNum" label="电话" placeholder="请输入电话" right-icon="arrow" input-align="right"></van-field>
      <van-field v-model="bed_total" label="床位数量" placeholder="请输入床位数量" right-icon="arrow" input-align="right"></van-field>
      <van-cell title="营业时间" is-link  @click="showPicker = true" :value="value" value-class="col_333" />
      <!--营业时间-弹窗-->
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
      </van-popup>
      <!--门店简介-->
      <div class="storeInfo__introduce bb_1">
        <div class="flex">
          <div>门店简介</div>
          <router-link :to="{path:'/storeInfo_intro',query:{store_id:store_id,intro_content:store_intro}}" class="intro__editBtn"><span class="iconfont icon-bianji"></span></router-link>
        </div>
        <div class="intro__text">{{store_intro}}</div>
      </div>
      <!--环境图片-->
      <div class="applyForm__upload">
        <div class="applyForm__title">环境图片</div>
        <div class="comment_uploadimg">
          <!-- <van-uploader  v-model="comment_imgbox" multiple :max-count="6" preview-size="55"/> -->
          <div class="van-uploader__wrapper">
            <div v-if="localIds.length > 0" class="fl">
              <div class="van-uploader__upload " v-for="(item,index) in localIds" :key="index">
                <img :src="item" class="radius" alt @click="previewImage(item)" />
                <p
                  class="close fs_12"
                  @click="deleImg(index)"
                  style="position: absolute;top: 0;right: .2rem;font-size: 1rem !important;color:#45b9bc;"
                >×</p>
              </div>
            </div>

            <div class="van-uploader__upload fl" v-if="localIds.length < 8" @click="selectImg">
              <i class="van-icon van-icon-plus van-uploader__upload-icon">
                <!---->
              </i>
            </div>
          </div>
        </div>
      </div>
    </van-cell-group>
    <div class="sureBtn__box"><button @click="submitBtn">确认保存</button></div>
  </div>
</template>

<script>
  // 营业时间-数组
  const hours = {
    0: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24'],
    1: ['00','30'],
    2: ['-'],
  };
  export default {
    name: "storeInfo",
    data(){
      return{
        store_id:0,
        addressDetails:'',
        phoneNum:'',
        storeImg_url:"",   //门店logo
        //营业时间
        value: '08:00 - 22:00',
        showPicker: false,
        bed_total:10,
        columns: [
          {
            values: hours[0],
            className: 'column1'
          },
          {
            values: hours[1],
            className: 'column2',
          },
          {
            values: hours[2],
            className: 'column3',
          },
          {
            values: hours[0],
            className: 'column4',
          },
          {
            values: hours[1],
            className: 'column5',
          },
        ],
        //门店简介
        store_intro:'本店环境卫生，服务周到，养生项目齐全，技师众多，有资深、首席技师各一名，技师服务技能出众技师服务技能出众技师服务技能出众，养生项目齐全，技师众多，有资深、首席技师各一名。',
        //上传-环境图片
        localIds: [], // 图片列表
        serverId: [] // 上传后返回的服务器id
      }
    },
    created(){
        this.store_id = this.$route.query.store_id;
        this.get_store();
    },
    methods: {
       get_store(){
        this.axios({
          url: this.api.store.store_center_detail,
          data: {
            store_id:this.store_id
          }
        }).then(res => {
          if (res.error === 0) {
            this.store = res.store;         
            this.storeImg_url = res.store.logo
            this.addressDetails = res.store.address
            this.phoneNum = res.store.tel
            this.value = res.store.sale_starttime+" - "+res.store.sale_endtime
            this.localIds = res.store.localIds
            this.store_intro = res.store.desc
            this.bed_total = res.store.bed_total
             this.url = res.url
          }
        });
      },
      clickPreview(){
        // this.storeImg_url = "";
      },
      // 营业时间-弹窗
      onConfirm(value) {
        this.value = value[0]+":"+value[1]+" "+value[2]+" "+value[3]+":"+value[4];
        this.showPicker = false;
      },
      // 确认保存-按钮
      submitBtn() {
        if (!this.storeImg_url) {
          this.$toast('请上传门店标志！');
          return false
        }
        if (!this.addressDetails) {
          this.$toast('请输入街道门牌！');
          return false
        }
        if (!this.phoneNum) {
          this.$toast('请输入电话！');
          return false
        }
        console.log(this.localIds);
        // let thumbs = this.localIds.concat(this.serverId)
        this.axios({
          url: this.api.store.store_detail_edit,
          data: {
            store_id:this.store_id,
            address:this.addressDetails,
            tel:this.phoneNum,
            sale_time:this.value,
            environment_img:this.fileList,
            bed_total:this.bed_total,
            localIds: this.localIds,
            thumbs: this.serverId
          }
        }).then(res => {
          if (res.error === 0) {
            this.$toast({
            message: res.msg,
            type: "success",
            onClose: () => {
              this.get_store();
            }
            }); 
          }   
}); 
      },
      selectImg() {
      var that = this;
      this.axios({
        url: this.api.index.share_url,
        data: {
          url: window.location.href.split("#")[0]
        }
      }).then(function(res) {
        var shareMsg = res.jssdkconfig;
        wx.config({
          appId: shareMsg.appId,
          timestamp: shareMsg.timestamp,
          nonceStr: shareMsg.nonceStr,
          signature: shareMsg.signature,
          jsApiList: ["chooseImage", "uploadImage", "previewImage"]
        });
        wx.ready(function() {
          wx.chooseImage({
            // count: 1, // 默认9
            sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
              res.localIds.forEach(v => {
                // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                that.localIds.push(v);
                that.upLoad_img();
              });
            }
          });
        });
      });
    },
    previewImage(url) {
      // 图片预览
      var that = this;
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: that.localIds // 需要预览的图片http链接列表
      });
    },
    deleImg(i) {
      this.localIds.splice(i, 1);
    },
    upLoad_img() {
      var that = this;
      var i = 0;
      var count = that.localIds.length;
        function upLoad() {
          // 多图上传
          wx.uploadImage({
            localId: that.localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            complete: function(res) {
              i++;
              that.serverId.push(res.serverId); // 返回图片的服务器端ID
              if (i < count) {
                upLoad(); // 递归上传图片
              } else {
                //that.post();
              }
            }
          });
        }
        upLoad();
    }
    }
  }
</script>

<style scoped>
  .applyForm{
    background: #fff;
  }
  .applyForm .van-cell{
    align-items: center;
    -webkit-align-items: center;
    padding: .6rem .75rem;
    line-height: 1.2rem;
    font-size: .7rem;
    color: #333;
  }
  .storeInfo__logo{
    line-height: 0!important;
  }
  .storeInfo__logo .van-cell__value{
    padding: .1rem 0!important;
  }
  .van-image{
    margin-right: 8px;
  }
  .storeInfo__introduce{
    padding: .6rem .75rem .6rem 0;
    font-size: .7rem;
    color: #333;
    margin-left: .75rem;
  }
  .intro__editBtn{
    padding: .15rem .25rem;
    color: #999;
  }
  .intro__editBtn .iconfont{
    font-size: 1rem;
    line-height: 1rem;
    height: 1rem;
  }
  .intro__text{
    padding: .4rem 0 .15rem;
    color: #999;
    line-height: 1.1rem;
    font-size: .65rem;
  }
  .applyForm__upload{
    padding: 0 .75rem .35rem;
    color: #333;
  }
  .applyForm__title{
    padding: .6rem 0;
    font-size: .7rem;
    line-height: 1.2rem;
    margin-bottom: .25rem;
  }
  .sureBtn__box{
    padding-top: 1.5rem;
  }
  .comment_uploadimg {
  padding: 0.4rem 0rem;
}
.comment_uploadimg li {
  width: 2.2rem;
  height: 2.2rem;
  line-height: 2.2rem;
  text-align: center;
  float: left;
  margin-right: 2.7%;
  margin-bottom: 0.5rem;
}
.comment_uploadimg li img {
  width: 100%;
  height: 100%;
}
.van-uploader__upload {
  width: 3.8rem;
  height: 3.8rem;
  float: left;
}
.van-uploader__upload img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeInfo.vue